import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconCreditCardNfc: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconCreditCardNfc"><Path d="M22 11C17.0294 11 13 15.0294 13 20H2V11H22Z" fill="currentColor"/><Path d="M22 15C19.2386 15 17 17.2386 17 20H15C15 16.134 18.134 13 22 13V15Z" fill="currentColor"/><Path d="M22 18.5C21.1716 18.5 20.5 19.1716 20.5 20H18.5C18.5 18.067 20.067 16.5 22 16.5V18.5Z" fill="currentColor"/><Path d="M22 9H2V4H22V9Z" fill="currentColor"/></CentralIconBase>;
});

export default IconCreditCardNfc;
